// material-ui
import { Grid, Typography, Link, Button, Box, Stack, Card, CardContent } from '@mui/material';

// project import
// import Avatar from 'components/@extended/Avatar';
import LinearWithLabel from 'components/@extended/progress/LinearWithLabel';
// import MainCard from 'components/MainCard';
import { CommentOutlined } from '@ant-design/icons';

// assets
// import Target from 'assets/images/analytics/target.svg';
import G2Logo from 'assets/images/icons/g2.png'; // update with the correct path to G2 logo
import TrustpilotLogo from 'assets/images/icons/trustpilot-2.svg';
// ==============================|| LABELLED TASKS ||============================== //

function ReviewsNumbers({ rating_percentages, review_sources }) {
  // const rating_percentages = useSelector((state) => state.reviewsReducer.analysisData.review_analysis_results.rating_percentages)
  // console.log(analysisData)

  // const numbers = rating_percentages.count
  // const totals = numbers.g2 + numbers.trustpilot
  const values = rating_percentages.sentiment;

  // let g2ReviewsCount = null; // replace with the actual review count if available
  // let trustpilotReviewsCount = null; // replace with the actual review count if available

  let trustpilotReviewLink = null;
  if (review_sources && review_sources.trustpilot) {
    trustpilotReviewLink = review_sources.trustpilot;
    //  trustpilotReviewsCount = rating_percentages.count.trustpilot
  }

  let g2ReviewLink = null;
  if (review_sources && review_sources.g2) {
    g2ReviewLink = review_sources.g2;
    // g2ReviewsCount = rating_percentages.count.g2
  }
  return (
    <Grid item xs={12}>
      <Card sx={{ display: 'flex', marginBottom: '32px' }}>
        <Box sx={{ backgroundColor: '#e8f5e9', width: '8px' }} />
        <CardContent sx={{ flexGrow: 1 }}>
          <Grid container spacing={1.25}>
            <Grid item xs={12}>
              <Stack direction="row" justifyContent="space-between" mb={1}>
                <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
                  <CommentOutlined style={{ fontSize: '28px', marginRight: '8px', color: 'green' }} />
                  <Typography variant="h4" color="primary">
                    Reviews sentiment
                  </Typography>
                </Box>

                <Box display="flex" alignItems="center" justifyContent="space-between">
                  {g2ReviewLink ? (
                    <Link
                      href={g2ReviewLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      underline="none"
                      style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                      <Button>
                        {/* <Badge badgeContent={g2ReviewsCount} max={9999} color="primary" variant="light" sx={{ mr: 1 }}> */}
                        <Box display="flex" alignItems="center">
                          <img src={G2Logo} alt="G2 Logo" style={{ width: 24, height: 24 }} />
                          {/* <Typography variant="body1">G2</Typography> */}
                        </Box>
                        {/* </Badge> */}
                      </Button>
                    </Link>
                  ) : null}
                  {trustpilotReviewLink ? (
                    <Link
                      href={trustpilotReviewLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      underline="none"
                      style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                      <Button>
                        {/* <Badge badgeContent={trustpilotReviewsCount} max={9999} color="primary" variant="light" sx={{ mr: 1 }}> */}
                        <Box display="flex" alignItems="center">
                          <img src={TrustpilotLogo} alt="Trustpilot Logo" style={{ width: 24, height: 24 }} />
                          {/* <Typography variant="body1">Trustpilot</Typography> */}
                        </Box>
                        {/* </Badge> */}
                      </Button>
                    </Link>
                  ) : null}
                </Box>
              </Stack>
            </Grid>
            <Grid item xs={3}>
              <Typography>Positive</Typography>
            </Grid>
            <Grid item xs={9}>
              <LinearWithLabel value={values['positive']} color="success" />
            </Grid>
            <Grid item xs={3}>
              <Typography>Neutral</Typography>
            </Grid>
            <Grid item xs={9}>
              <LinearWithLabel value={values['neutral']} color="warning" />
            </Grid>
            <Grid item xs={3}>
              <Typography>Negative</Typography>
            </Grid>
            <Grid item xs={9}>
              <LinearWithLabel value={values['negative']} color="error" />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
}

export default ReviewsNumbers;
